export const DEV_MODE_OVERRIDE_STORAGE_KEY = "adminSchedulingDeveloperModeOverride_v1";
const DEV_MODE_CHANGED_EVENT = "adminSchedulingDeveloperModeChanged";

export function readDeveloperModeFlag() {
  try {
    return localStorage.getItem(DEV_MODE_OVERRIDE_STORAGE_KEY) === "1";
  } catch (error) {
    return false;
  }
}

export function writeDeveloperModeFlag(enabled) {
  try {
    localStorage.setItem(DEV_MODE_OVERRIDE_STORAGE_KEY, enabled ? "1" : "0");
  } catch (error) {}

  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(DEV_MODE_CHANGED_EVENT, { detail: { enabled: !!enabled } }));
  }
}

export function subscribeDeveloperModeFlag(listener) {
  if (typeof window === "undefined" || typeof listener !== "function") {
    return () => {};
  }

  const notify = () => listener(readDeveloperModeFlag());
  const handleStorage = (event) => {
    if (event.key !== DEV_MODE_OVERRIDE_STORAGE_KEY) return;
    notify();
  };

  window.addEventListener("storage", handleStorage);
  window.addEventListener(DEV_MODE_CHANGED_EVENT, notify);

  return () => {
    window.removeEventListener("storage", handleStorage);
    window.removeEventListener(DEV_MODE_CHANGED_EVENT, notify);
  };
}
